var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarAge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.067,
    height: 80,
    viewBox: "0 0 55.067 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(-418.498 -231.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5317",
    "data-name": "Path 5317",
    d: "M447.581,231.8a60.4,60.4,0,0,1,5.957,1.113,26.793,26.793,0,0,1,14.043,9.355,25.937,25.937,0,0,1,5.332,11.328c1.172,5.918.918,11.719-2.031,17.148a28.668,28.668,0,0,1-5.078,6.406c-1.8,1.816-3.613,3.613-5.273,5.527a20.53,20.53,0,0,0-4.98,13.555,16.44,16.44,0,0,1-1.523,7.422,14.342,14.342,0,0,1-10.957,7.988,2.529,2.529,0,0,0-.508.156h-2.969a37.522,37.522,0,0,1-3.672-.977,14.446,14.446,0,0,1-9.336-13.437,2.685,2.685,0,0,1,2.539-2.754A2.6,2.6,0,0,1,431.858,297a11.389,11.389,0,0,0,1.27,4.863,9.134,9.134,0,0,0,17.051-4.336,38.773,38.773,0,0,1,.879-7.812,25.768,25.768,0,0,1,6.367-11.641c1.953-2.09,4.023-4.082,6-6.152a16.36,16.36,0,0,0,4.57-9.121,22.24,22.24,0,0,0-42.441-12.109,21.85,21.85,0,0,0-1.738,7.949,8.972,8.972,0,0,1-.1,1.25,2.614,2.614,0,0,1-2.871,2.09,2.557,2.557,0,0,1-2.344-2.559,26.909,26.909,0,0,1,2.324-11.133,27.443,27.443,0,0,1,11.758-12.949,26.45,26.45,0,0,1,11.094-3.4c.254-.02.508-.078.762-.117C445.491,231.8,446.545,231.8,447.581,231.8Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5318",
    "data-name": "Path 5318",
    d: "M478.021,315.871a12.383,12.383,0,0,1,7.322,3.732,12.5,12.5,0,0,1-6.608,20.9,12.148,12.148,0,0,1-8.5-1.346,2.808,2.808,0,0,1-1.326-3.793,2.71,2.71,0,0,1,3.753-1.183,7.424,7.424,0,0,0,6.363.469,6.961,6.961,0,0,0,4.181-7.22,6.841,6.841,0,0,0-5.792-5.976c-.653-.082-1.305-.061-1.958-.082a2.683,2.683,0,0,1-2.9-2.59,51.216,51.216,0,0,1-.245-7.893,16.25,16.25,0,0,1,32.1-2.2,20.262,20.262,0,0,1,.347,3.161,2.705,2.705,0,0,1-2.447,2.916,2.677,2.677,0,0,1-3.039-2.509,13.906,13.906,0,0,0-1.1-4.895,10.709,10.709,0,0,0-11.013-5.935,10.559,10.559,0,0,0-9.116,9.015A48.056,48.056,0,0,0,478.021,315.871Z",
    transform: "translate(-39.882 -50.971)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarAge);
export default __webpack_public_path__ + "static/media/EarAge.67008bde5608c2a504f475101b56aea4.svg";
export { ForwardRef as ReactComponent };